import dayjs from "dayjs";
import React, { useCallback } from "preact/compat";
import { useEffect, useRef, useState } from "react";
import { animations } from "../../../Constants/animations";
import { app_env } from "../../../config/constant";
import { sendDataToApp } from "../../../utils/android";
import { trans } from "../../../utils/utilsTrans";
import RenderReactGrid from "../../Layout/RenderReactGrid";
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const Flow = ({ isApp, translations, setInitTime, flow, orientation, onEnd, nextFlow, updateArea, blackListFrame, company, isReverse, preview_data, flowHistory }) => {
  const [currentTimeout, setCurrentTimeout] = useState(null);
  const [numberFrame, setNumberFrame] = useState(0);
  const [displayAnimation, setDisplayAnimation] = useState(false);
  const [disableNext, setDisableNext] = useState(true);
  const [indexCurrent, setIndexCurrent] = useState(0);
  const numberFrameRef = useRef(numberFrame);
  const nextFlowRef = useRef(nextFlow?.id);
  numberFrameRef.current = numberFrame;
  nextFlowRef.current = nextFlow?.id;


  // Rajoute un délai pour afficher l‘écran suivant ! Ne pas supprimer !!
  useEffect(() => {
    const onReady = setTimeout(() => sendDataToApp("ready"), 2000);

    return () => clearTimeout(onReady);
  }, []);

  useEffect(() => {
    if (nextFlow?.id !== flow.id && nextFlow?.id) { setDisableNext(false); }
  }, [nextFlow?.id]);

  useEffect(() => {
    setInitTime(dayjs().format('YYYYMMDDHHmm'));
    setDisplayAnimation(false);
  }, [flow.uniqId]);

  const prepareEnd = useCallback(() => {
    setDisableNext(true);
    setDisplayAnimation(true);
    setNumberFrame(0);
    onEnd();
  }, []);

  const handleEvent = useCallback((eventType, areaSlug, data) => {
    const frame_count = parseInt(flow.endOn?.frame_count ?? flow.areas[0]?.data?.length) || flow.areas[0]?.data?.length;

    if (Object.keys(flowHistory).length === 1 && eventType === "end") {
      return null;
    }

    switch (eventType) {
      case "endSlider":
      case "end":
        prepareEnd();
        break;
      case "blackListFrame":
        blackListFrame(areaSlug, data);
        break;
      case "updateFrame": {
        const nextFrameCount = numberFrameRef.current + 1;

        if (frame_count && (nextFrameCount >= frame_count || nextFrameCount >= flow.areas[0]?.data?.length) && nextFlowRef.current) {
          prepareEnd();
          return false;
        } else {
          setNumberFrame(nextFrameCount < flow.areas[0]?.data?.length ? nextFrameCount : 0);
          return true;
        }
        break;
      }
    }

    return true;
  }, [flow.uniqId, flowHistory, prepareEnd, onEnd, blackListFrame]);

  return (
    <div
      className={"fullscreen flip-card no_cpu"}
      onAnimationEnd={(animation) => {
        if (
          [
            'otherTest',
            'main-transition-2',
            'main-transition-3',
            'main-transition-4',
            'main-transition-5',
            'test-6',
            'main-transition-7'
          ].includes(animation.animationName)
        ) {
          onEnd()
          setIndexCurrent(indexCurrent === 0 ? 1 : 0)
        }
      }}
    >
      <RenderReactGrid
        updateArea={updateArea}
        selectedAnimation={animations[6]}
        isUniq={!flow.next}
        key={flow?.id}
        company={company}
        preview_data={preview_data}
        width={isReverse ? window.innerHeight : window.innerWidth}
        compactType={orientation}
        handleEvent={handleEvent}
        flow={flow}
        isReverse={isReverse}
        displayAnimation={displayAnimation}
        visibleState={0}
      />
      {app_env === "dev" || preview_data?.preview_flow ? (
        <div className='navigation'>
          <button type={"button"} disabled={disableNext} onClick={(event) => {
            event.stopImmediatePropagation();
            prepareEnd()
          }}>
            <span className='block'>{trans('next_model', translations)}</span> <i className='ic-chevron-right' /></button>
        </div>
      ) : false}
    </div>
  );
}

export default React.memo(Flow, (props, nextProps) => {
  return props.flow?.uniqId === nextProps.flow?.uniqId && props.flow?.id === nextProps.flow?.id && props.nextFlow?.uniqId === nextProps.nextFlow?.uniqId && props.nextFlow?.id === nextProps.nextFlow?.id
})
